module.exports = __webpack_public_path__ + "static/vegas2-7ee95ad10d1bf23b76ef60e4f17608e5.png";